import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5b46d770&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5b46d770&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46d770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b46d770')) {
      api.createRecord('5b46d770', component.options)
    } else {
      api.reload('5b46d770', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5b46d770&scoped=true&", function () {
      api.rerender('5b46d770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/beauty/detail.vue"
export default component.exports